import { RouteRecordRaw } from "vue-router";
import {
  projectCreateRoute,
  projectEditRoute,
  projectListRoute,
  projectSchemaRoute,
} from "@/pages/project/router";
import {
  userCreateRoute,
  userEditRoute,
  userListRoute,
} from "@/pages/user/router";
import { previewRoute } from "@/pages/preview/router";
import { registerSignInRoute, registerSignUpRoute } from "@/pages/auth/router";

export const AdminLayoutRoute: RouteRecordRaw = {
  path: "/",
  name: "ADMIN_LAYOUT",
  meta: {
    isLayout: true,
  },
  component: () => import("@/layouts/BaseLayout.vue"),
  children: [
    previewRoute,
    projectListRoute,
    projectCreateRoute,
    projectEditRoute,
    projectSchemaRoute,
    userListRoute,
    userCreateRoute,
    userEditRoute,
  ],
};

export const ManagerLayoutRoute: RouteRecordRaw = {
  path: "/",
  name: "MANAGER_LAYOUT",
  meta: {
    isLayout: true,
  },
  component: () => import("@/layouts/BaseLayout.vue"),
  children: [
    projectListRoute,
    projectCreateRoute,
    projectEditRoute,
    projectSchemaRoute,
  ],
};

export const UserLayoutRoute: RouteRecordRaw = {
  path: "/",
  name: "USER_LAYOUT",
  meta: {
    isLayout: true,
  },
  component: () => import("@/layouts/BaseLayout.vue"),
  children: [previewRoute],
};

export const AuthLayoutRoute: RouteRecordRaw = {
  path: "/auth",
  name: "AUTH_LAYOUT",
  meta: {
    isLayout: true,
  },
  component: () => import("@/layouts/AuthLayout.vue"),
  children: [registerSignInRoute, registerSignUpRoute],
};
